import {ImageOpNodeBag} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/image-op-node-bag"
import {ImageOpNodeCreateImage} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/create-image/node"
import {ImageOpNodeConvertColorSpace} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/convert-color-space/node"
import {ImageOpSystem} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-system"
import {readTexel} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/evaluate-and-read-texel"

// Converts a single picked color to Lab mean values by reading back the texel of a 1x1 image
// directly, rather than running it through ImageOpNodeMeanAndVariance (which has a bug for
// already-1x1 inputs: its reduction loop exits before applying the sum-of-squares preprocess step,
// so it reports a spurious ~0.5 "variance" instead of 0). For a single color, the mean is just the
// pixel's own Lab value, so no reduction is needed at all.
export async function computeLabMeanFromColor(rgb: [number, number, number], imageOpSystem: ImageOpSystem): Promise<{l: number; a: number; b: number}> {
    const bag = new ImageOpNodeBag("recolorTargetMeanFromColor")
    bag.beginFrame()
    const createdImage = bag.getNode("createImage", ImageOpNodeCreateImage, {
        descriptor: {width: 1, height: 1, channels: 4},
        data: new Float32Array([rgb[0], rgb[1], rgb[2], 1]),
    })
    // rgb comes from parseColor (@cm/utils), which returns gamma-encoded sRGB values, not linear
    const labImage = bag.getNode("labMean", ImageOpNodeConvertColorSpace, {
        sourceImage: createdImage,
        sourceColorSpace: "srgb",
        targetColorSpace: "lab",
    })
    bag.endFrame()

    try {
        const [l, a, b] = await readTexel(await imageOpSystem.evaluate("hal", labImage))
        return {l, a, b}
    } finally {
        bag.dispose()
    }
}
